import React from 'react';
import { Helmet } from 'react-helmet-async';
import MiroFishSwarm from '../components/MiroFishSwarm';

const NewsAISwarm = () => {
  return (
    <>
      <Helmet>
        <title>News AI Swarm Simulator | Harry Vadalkar</title>
        <meta name="description" content="MiroFish Investor Swarm - Multi-agent behavioral finance simulation engine. Watch AI agents react to real financial news headlines in real-time." />
        <meta property="og:title" content="News AI Swarm Simulator | Harry Vadalkar" />
        <meta property="og:description" content="MiroFish Investor Swarm - Multi-agent behavioral finance simulation engine. Watch AI agents react to real financial news in real-time." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="News AI Swarm Simulator" />
        <meta name="twitter:description" content="Watch AI agents react to real financial news headlines in real-time behavioral finance simulation." />
      </Helmet>

      <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)',
          padding: '40px 20px',
          textAlign: 'center'
        }}>
          <p style={{ 
            fontSize: '12px', 
            letterSpacing: '3px', 
            color: '#94a3b8', 
            marginBottom: '12px',
            textTransform: 'uppercase'
          }}>
            VITTA FINANCE ACADEMY
          </p>
          <h1 style={{
            fontSize: 'clamp(28px, 5vw, 48px)',
            fontWeight: 800,
            color: '#fff',
            marginBottom: '16px',
            fontFamily: "'Playfair Display', serif"
          }}>
            News AI Swarm Simulator
          </h1>
          <p style={{
            fontSize: '16px',
            color: '#94a3b8',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Multi-agent behavioral finance simulation • 164 US & Canadian stocks • Real-time AI analysis
          </p>
        </div>

        {/* Main Content */}
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px 16px' }}>
          {/* Token Warning Banner */}
          <div style={{
            background: 'linear-gradient(135deg, #fef3c7, #fef9c3)',
            border: '1px solid #fde68a',
            borderRadius: '12px',
            padding: '16px 20px',
            marginBottom: '20px',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '16px'
          }}>
            <div style={{ flex: 1, minWidth: '280px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                <span style={{ fontSize: '20px' }}>⚠️</span>
                <span style={{ fontWeight: 700, color: '#92400e', fontSize: '14px' }}>AI Token Usage Notice</span>
              </div>
              <p style={{ margin: 0, fontSize: '13px', color: '#78350f', lineHeight: 1.5 }}>
                This feature uses AI (Claude Sonnet) to fetch live financial news headlines. Each refresh consumes tokens (~1,500 per call). 
                <strong> If my token balance runs low, this feature may temporarily stop working.</strong>
              </p>
            </div>
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank" style={{ margin: 0 }}>
              <input type="hidden" name="cmd" value="_donations" />
              <input type="hidden" name="business" value="harryvadalkar@gmail.com" />
              <input type="hidden" name="item_name" value="AI Token Donation - News AI Swarms" />
              <input type="hidden" name="currency_code" value="CAD" />
              <input type="hidden" name="amount" value="5" />
              <button 
                type="submit"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  background: '#0070ba',
                  color: '#fff',
                  padding: '14px 28px',
                  borderRadius: '25px',
                  border: 'none',
                  fontWeight: 700,
                  fontSize: '14px',
                  cursor: 'pointer',
                  boxShadow: '0 4px 14px rgba(0,112,186,0.4)',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'
                }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 3.384a.78.78 0 0 1 .771-.654h6.583c2.188 0 3.894.586 5.008 1.714.98.99 1.394 2.316 1.258 4.048-.015.19-.036.385-.065.583-.449 2.976-2.039 5.009-4.735 6.046-1.146.441-2.428.659-3.833.659H8.06a.776.776 0 0 0-.766.654l-.962 5.903h-.256zm2.17-7.837h1.685c2.296 0 3.927-.654 4.87-1.948.62-.852.953-1.861 1.013-3.066.045-.941-.18-1.647-.685-2.151-.544-.544-1.447-.821-2.687-.821H9.962l-1.716 7.986z"/>
                </svg>
                Donate $5 CAD
              </button>
            </form>
          </div>

          {/* MiroFish Swarm Component */}
          <div style={{
            background: '#fff',
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            overflow: 'hidden',
            minHeight: '600px'
          }}>
            <MiroFishSwarm />
          </div>

          {/* Footer */}
          <div style={{
            textAlign: 'center',
            padding: '32px 16px',
            color: '#64748b',
            fontSize: '14px'
          }}>
            <p style={{ margin: '0 0 8px 0' }}>
              Part of the <a href="/investment-academy" style={{ color: '#3b82f6', textDecoration: 'none' }}>Investment Academy</a> by Harry Vadalkar
            </p>
            <p style={{ margin: 0 }}>
              <a href="/" style={{ color: '#64748b', textDecoration: 'none' }}>← Back to Main Site</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsAISwarm;
